module.exports = __webpack_public_path__ + "static/media/Laugo_15.78b78061.jpg";